// src/modals/RecordSaleModal.js
import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useRecordSaleMutation } from "../api/api";
import { getApiErrorMessage } from "../api/errorUtils";

const RecordSaleModal = ({
  modalOpen,
  toggleModal,
  addNewItem,
  administrationSalesData,
  notificationMessage,
}) => {
  const [formData, setFormData] = useState({
    articleId: "",
    price: "",
    article_name: "",
  });

  const [recordSale, { isLoading }] = useRecordSaleMutation();

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "articleId") {
      const selectedArticle = administrationSalesData.find(
        (a) => a.id === Number(value)
      );
      setFormData((prev) => ({
        ...prev,
        articleId: Number(value),
        article_name: selectedArticle ? selectedArticle.name : "",
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async () => {
    try {
      if (!formData.articleId) {
        notificationMessage("warning", "Please select an article.");
        return;
      }
      if (!formData.price) {
        notificationMessage("warning", "Please enter a price.");
        return;
      }

      // RTK mutation (unwrap throws if error)
      const res = await recordSale({
        articleId: formData.articleId,
        price: Number(formData.price),
      }).unwrap();

      // Expecting backend like: { data: { createdAt, saleInsertID } }
      const { createdAt, saleInsertID } = res?.data || res || {};

      addNewItem({
        id: saleInsertID,
        name: formData.article_name,
        price: formData.price,
        date: createdAt,
      });

      setFormData({ articleId: "", price: "", article_name: "" });
      toggleModal(); // close
      notificationMessage("success", "Sale recorded successfully.");
    } catch (error) {
      const msg = getApiErrorMessage(error, "Error on recording sale", {
        404: "That administration article is no longer available in your company scope.",
        409: "That administration article cannot be sold in its current stock state.",
      });
      notificationMessage("danger", msg);
      // keep modal open for correction
    }
  };

  return (
    <Modal
      className="record-sale-modal"
      isOpen={modalOpen}
      toggle={toggleModal}
    >
      <ModalHeader toggle={toggleModal}>Record Sale</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label htmlFor="articleId">Select Article</Label>
            <Input
              type="select"
              name="articleId"
              id="articleId"
              value={formData.articleId}
              onChange={handleInputChange}
            >
              <option value="" disabled>
                Select an article
              </option>
              {administrationSalesData.map((article) => (
                <option key={article.id} value={article.id}>
                  {article.name}
                </option>
              ))}
            </Input>
          </FormGroup>

          <FormGroup>
            <Label htmlFor="price">Price</Label>
            <Input
              type="number"
              name="price"
              id="price"
              value={formData.price}
              onChange={handleInputChange}
              placeholder="Enter Price"
              min="0"
              step="0.01"
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? "Saving..." : "Save"}
        </Button>
        <Button color="secondary" onClick={toggleModal} disabled={isLoading}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RecordSaleModal;
